import React, { useEffect, useState, ReactNode } from 'react';
import CardDetailsReview from '../../../../pages/menuReviews/3_1_Reviews/Reviews/CardDetailsReview';
import Reviews from './Reviews';
import { useFetch } from '../../../../../hooks/useFetch/useFetch';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import moment from 'moment';
import { FilterFilled, ForwardOutlined, SlidersOutlined, StarFilled, StarOutlined } from '@ant-design/icons';
import { DatePicker, Radio, Segmented, Spin, Tooltip } from 'antd';
import SelectPeriod from '../../selectMonths/SelectPeriod';
import reviews from '../../../../../assets/reseñas-empty-component.png'
import './ReviewsContainer.css';
import { CSVDownloadServer } from '../../../../../common/utils/CSVDownloadServer';
import { PageFilters, PageFilterField } from '../../../../pages/common/PageFilters';
import { ResultsPagination } from '../../../design/ResultsPagination/ResultsPagination';
import { EmptyStateBox } from '../../../design/EmptyStateBox/EmptyStateBox';

export default function ReviewsContainer({ abovePagination }: { abovePagination?: ReactNode }) {
  
  const { projectGroup } = useAuth();

  const [selectedReview, setSelectedReview] = useState<any>(null);
  const [refreshReviews, setRefreshReviews] = useState(false);
  const [reviewsData, setReviewsData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [currentGroup, setCurrentGroup] = useState(projectGroup.group);
  const [filterStatus, setFilterStatus] = useState('&status=NOT_REPLIED');
  const [filterScore, setFilterScore] = useState('');
  const [filterReference, setFilterReference] = useState('&periodOpt=LAST_30DAYS');
  const [requestParams, setRequestParams] = useState(filterStatus + filterScore + filterReference);
  const [pagination, setPagination] = useState<any>({page:1});  
  const [categories, setCategories] = useState([]);    	  
  
  useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/category`
    , {},[]  ,(data) => {          
      setCategories(data);					
    }
  );

  const handleReviewClick = (review: React.SetStateAction<null>) => {    
    setSelectedReview(review);
  };

  useEffect(() => {    
    
    setSelectedReview(null);      
    setRequestParams(filterStatus + filterScore + filterReference); // Hace falta realmente ???
    setCurrentGroup(projectGroup.group);					
  }, [projectGroup])

  useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/' + currentGroup + `/reviews?${requestParams}`
		, {}, [refreshReviews],
		(data) => {      
     
			setReviewsData(data.reviews);
      setPagination(data.pagination);
      setIsLoading(false);
		});

    const onRangeChange = (range: any) => {
      setFilterReference('&periodOpt=' + range);
      handleResquestParam(filterStatus + filterScore + '&periodOpt=' + range);      
    };

  function handleResquestParam(requestParams: string) {
    setSelectedReview(null);
    setRequestParams(requestParams);
  }

  function nextReview(currentReview: any) {          
      if (reviewsData && currentReview.nextReview) {
          const nextReview  = reviewsData.find((element: { name: string; }) => element.name === currentReview.nextReview);      
          setSelectedReview(nextReview);      
      } else {
          setSelectedReview(null)            
      }
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', borderRadius:'15px', margin:'25px 0px 0px 0px', alignItems:'center', gap: 16, flexWrap: 'wrap'}}>
          {abovePagination}
            <PageFilters>
            <PageFilterField label='Estado' active={filterStatus !== ''}>
            <Segmented
              value={filterStatus}
              options={[
                { label: 'Todas', value: '' },
                { label: filterStatus === '&status=NOT_REPLIED' ? <b style={{color: 'royalblue'}}>Pendientes</b>  : <>Pendientes</>, value: '&status=NOT_REPLIED'},
                { label: filterStatus === '&status=REPLIED' ? <b style={{color: 'royalblue'}}>Respondidas</b>  : <>Respondidas</>, value: '&status=REPLIED' }
              ]}
              onChange={(value: any) => { setIsLoading(true); setFilterStatus(value); handleResquestParam(value + filterScore + filterReference) }}
            />
            </PageFilterField>
            <PageFilterField label='Puntuación' active={filterScore !== ''}>
            <Segmented
              value={filterScore}
              options={[
                { label: 'Todas', value: '' },
                {
                  label: (
                    <Tooltip title='Positivas'>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, color: '#389e0d' }}>
                        <StarFilled />
                        <StarFilled />
                        <StarFilled />
                        <StarFilled />
                      </span>
                    </Tooltip>
                  ),
                  value: '&score=POSITIVES',
                },
                {
                  label: (
                    <Tooltip title='Negativas'>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, color: 'crimson' }}>
                        <StarFilled />
                        <StarFilled />
                      </span>
                    </Tooltip>
                  ),
                  value: '&score=NEGATIVES',
                },
              ]}
              onChange={(value: any) => { setIsLoading(true); setFilterScore(value); handleResquestParam(filterStatus + value + filterReference) }}
            />
            </PageFilterField>

            {/*<div>Rango <DatePicker.RangePicker format='DD-MM-YYYY' size='small' 
                        onChange={(value: any) => { 
                            let rangeFilter = value ? '&start=' + value[0].format('YYYY-MM-DD') + '&end=' + value[1].format('YYYY-MM-DD') : ''; 
                            setFilterReference(rangeFilter); 
                            handleResquestParam(filterStatus + filterScore + rangeFilter) }} />
                        </div>*/}

            <PageFilterField label='Periodo'>
            <SelectPeriod setSelectedType={onRangeChange} defaultValue='LAST_30DAYS'/>
            </PageFilterField>
            </PageFilters>       	                    
        </div>

        <div style={{ position: 'relative', marginTop: '0px' }} >                     
          <div style={{ width: '56%' }}>
          {reviewsData && (
            <ResultsPagination
              pagination={pagination}
              pageItemsCount={reviewsData.length}
              style={{ marginBottom: -4 }}
              onPrev={() => {
                setIsLoading(true);
                handleResquestParam('page=' + (pagination.page - 1) + filterStatus + filterScore + filterReference);
              }}
              onNext={() => {
                setIsLoading(true);
                handleResquestParam('page=' + (pagination.page + 1) + filterStatus + filterScore + filterReference);
              }}
            />
          )}
          {isLoading ? (
            <Spin/>
          ) : !reviewsData?.length ? (
            <div style={{ margin: '12px 0' }}>
              <EmptyStateBox
                icon={<StarOutlined />}
                title="No hay reseñas"
                description="No hay reseñas para los filtros seleccionados."
              />
            </div>
          ) : (
            <Reviews
              reviewsData={reviewsData}
              selectedReview={selectedReview}
              handleReviewClick={handleReviewClick} 
              categories={categories}
              width="100%"
            />
          )}
        </div>
        <div>          
          {selectedReview ? 
            <>
              <CardDetailsReview reviewId={selectedReview.name} onFinish={() => {setRefreshReviews(!refreshReviews); nextReview(selectedReview)}} categories={categories}/>              
            </>
            :
            <div className={'review-faq-container'}
            style={{ marginTop:'15px', background: 'white' }}>
            <div className="no-row-select">
              <img src={reviews} />
              <h1 >No tienes ninguna reseña seleccionada</h1>
              <span>Selecciona alguna para leerla</span>
            </div>
            </div>
          }
        </div>
        {!!reviewsData?.length && (
          <CSVDownloadServer
            url={`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/csv/reviews?${filterStatus}${filterScore}${filterReference}`}
            fileName='Lista de Reseñas.csv'
          />
        )}
      </div>
    </>                                                                                                                                         
  );
}

